export default "/_next/static/images/19296bc341b58f04c8bcb830f97ec645.png";